import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

/**
 * Auth-aware loading screen with an escape hatch.
 *
 * Shows a spinner immediately. After 8 seconds of continuous loading, also
 * surfaces a "Sign out" button so the user is never trapped in a hung auth
 * state (white screen with no way out).
 */
export function AuthLoadingScreen() {
  const { signOut } = useAuth();
  const [showEscape, setShowEscape] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowEscape(true), 8000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
        {showEscape && (
          <div className="space-y-2 max-w-sm">
            <p className="text-sm text-muted-foreground">
              Taking longer than expected. If this persists, sign out and back in.
            </p>
            <div className="flex gap-2 justify-center">
              <Button
                variant="outline"
                size="sm"
                onClick={() => window.location.reload()}
              >
                Reload
              </Button>
              <Button
                variant="default"
                size="sm"
                onClick={() => {
                  signOut().finally(() => {
                    window.location.replace("/auth");
                  });
                }}
              >
                Sign out
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
